export const PERSONALITY_DATA_COLLECTION_BASE_URL = '/personality-test-data-collection';

export const personalityDataCollectionLinks = {
    form: (localeName: string) => `${PERSONALITY_DATA_COLLECTION_BASE_URL}/${localeName}`,
    completed: (personalityTestId: string) =>
        `${PERSONALITY_DATA_COLLECTION_BASE_URL}/${personalityTestId}/completed`
};
